import backgroundImage from "../../assets/images/product-1.jpg";

const fixture = {
  image: backgroundImage,
  name: 'Some Product',
  price: '1200',
};

export default fixture;
